<ion-content [fullscreen]="true">
	<div class="page-creation-patient__container">
	  <div class="page-creation-patient__content">
			<div class="content__title">
				<h1 class="content__title-text">{{this.idPatient? "Modification Patient" :"Nouveau Patient"}}</h1>
			</div>
			<di-formulaire-patient [patient]="model" [onSubmit]="this.idPatient ? editPatient : createPatient" [showIdentityInputs]="true" [showLocationInputs]="true" [libelleButton]="idPatient ? 'Modifier le dossier du patient' : 'Créer le dossier du patient'"></di-formulaire-patient>
		</div>
	</div>
</ion-content>
